'use client';
import { enCodeLink, formatFullDate } from '@/utils';
import Image from 'next/image';
import { CirclePlay, ChevronDown } from 'lucide-react';
import ReUsableShareSheet from '@/components/ReUsables/ReUsableShareSheet';
import { useEffect, useState } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import authorDefaultImage from '../../../assets/authorDefaultImage.png';

export default function Banner({ update, onListenNowClick }: any) {
    // console.log(update);
    const [host, setHost] = useState('');

    const [anchorEl, setAnchorEl] = useState<any>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        setHost(window.location.origin);
    }, []);

    // Function to calculate reading time
    const calculateReadingTime = (text: string) => {
        const wordsPerMinute = 180;
        const wordCount = text ? text.split(/\s+/).length : 0;
        const readingTime = Math.ceil(wordCount / wordsPerMinute);
        return readingTime;
    };

    const readingTime = calculateReadingTime(update.para);

    return (
        <div className="max-w-[100%] mx-auto lg:border-r-[1px] border-solid border-[#C7C7C7] px-4 sm:px-2">
            <div className="max-w-[100%] lg:max-w-[95%]">
                <button className="mb-4 px-3 py-1 bg-[#A7D9FA] uppercase text-black rounded-lg shadow-sm hover:shadow-lg lg:text-[16px] text-xl font-medium ">
                    {update.editorialType.type}
                </button>
                <div
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(update.headLine) }}
                    className="mb-4 leading-tight"
                    style={{
                        fontFamily: 'PT Serif',
                        fontWeight: 500,
                        fontSize: window.innerWidth > 768 ? '52px' : '24px',
                        lineHeight: window.innerWidth > 768 ? '50px' : '30px',
                        // letterSpacing: '-0.3',
                    }}
                />
                <div
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(update.description) }}
                    className="editor text-base lg:text-lg text-muted-foreground text-[#9BA1A5]"
                    style={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: '500',
                        fontSize: '16px',
                        lineHeight: '24px',
                    }}
                />
                <p
                    className="mb-4 mt-4 text-xs lg:text-lg text-muted-foreground font-serif flex items-center gap-2"
                    style={{ fontFamily: 'Times New Roman, Times, serif' }}
                >
                    {formatFullDate(update.date)} <span className="text-black">●</span>
                    <span className="text-green-700 font-medium">{readingTime} min read</span>
                </p>
                <div className="mb-6 mt-2 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 border-t-[1px] border-solid border-[#C7C7C7] py-2">
                    <div className="flex items-center gap-3 ">
                        {/* <div className="h-10 w-10 lg:h-12 lg:w-12 rounded-full border-2 border-solid border-red-600"> */}
                        {update.authorImage ? (
                            <Image
                                src={update.authorImage}
                                alt="Profile Image"
                                className="rounded-full w-10 h-10 lg:h-12 lg:w-12 border-[1px] border-solid border-gray-200"
                                width={1000}
                                height={1000}
                                style={{ objectFit: 'contain' }}
                            />
                        ) : (
                            <Image
                                src={authorDefaultImage}
                                alt="Default Profile Image"
                                className="rounded-full w-10 h-10 lg:h-12 lg:w-12 border-[1px] border-solid border-gray-200"
                                width={1000}
                                height={1000}
                                style={{ objectFit: 'contain' }}
                            />
                        )}
                        {/* </div> */}
                        <div>
                            <h3
                                className="font-semibold text-md lg:text-base"
                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(update.subHeadLine) }}
                                style={{ fontFamily: 'Inter, sans-serif', fontSize: '20px' }}
                            />
                            {/* <p
                                className="text-xs lg:text-sm text-muted-foreground"
                                style={{ fontFamily: 'Inter', fontWeight: '400', fontSize: '14px', lineHeight: '20px' }}
                            >
                                Medical Journalist
                            </p> */}
                        </div>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto sm:justify-center text-[#666666]">
                        <button
                            onClick={handleClick}
                            className="w-full py-2 px-3 sm:w-auto border-[1px] border-solid border-[#B8B8B8] flex items-center justify-center sm:justify-start hover:bg-[#B1DFFF] transition-transform duration-200 transform hover:scale-105 cursor-pointer rounded-xl hover:shadow-[rgba(0,0,0,0.25)_0px_14px_28px,rgba(0,0,0,0.22)_0px_10px_10px] bg-[#FFFFFF]"
                        >
                            <span
                                style={{ fontFamily: 'Inter', fontWeight: '400', fontSize: '14px', lineHeight: '20px' }}
                            >
                                Share
                            </span>
                            <ChevronDown className="ml-2" />
                        </button>
                        <button
                            onClick={onListenNowClick}
                            className="w-full sm:w-auto border-[1px] border-solid border-[#B8B8B8] py-2 px-2 flex items-center justify-center sm:justify-start hover:bg-[#B1DFFF] transition-transform duration-200 transform hover:scale-105 cursor-pointer rounded-xl hover:shadow-[rgba(0,0,0,0.25)_0px_14px_28px,rgba(0,0,0,0.22)_0px_10px_10px] bg-[#FFFFFF]"
                        >
                            <span
                                style={{ fontFamily: 'Inter', fontWeight: '400', fontSize: '14px', lineHeight: '20px' }}
                            >
                                Listen Now
                            </span>
                            <CirclePlay className="ml-2 h-[24px] w-[24px] " />
                        </button>
                    </div>
                </div>
                <div className="mb-6">
                    <Image src={update?.mediaLink} width={1700} height={1200} alt="OneUp Banner" className="w-full" />
                </div>
                <ReUsableShareSheet
                    anchorEl={anchorEl}
                    open={open}
                    handleClose={handleClose}
                    url={`${host}${enCodeLink(update.headLine, update.editorialId)}`}
                />
            </div>
        </div>
    );
}
